export const getSchemaOrgFAQ = FAQContent => {
  const itemQuestionElement = [];

  FAQContent.forEach(element => {
    itemQuestionElement.push({
      '@type': 'Question',
      name: element.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: element.answer,
      },
    });
  });

  return {
    '@context': 'http://schema.org',
    '@type': 'FAQPage',
    name: 'FAQSchema',
    mainEntity: itemQuestionElement,
  };
};
